import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { ROUTESPATH } from './core/config/constants';
import { ChangePasswordTokenComponent } from '@views/public/change-password-token/change-password-token.component';

const routes: Routes = [
  {
    path: '',
    redirectTo: ROUTESPATH.LOGIN,
    pathMatch: 'full',
  },
  {
    path: ROUTESPATH.CHANGE_PASSWORD,
    component: ChangePasswordTokenComponent,
  },
  {
    path: '',
    loadChildren: () =>
      import('./views/views.module').then((m) => m.ViewsModule),
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
